<template>
    <div class="o-users">
        <m-title title="Lista klientów" />
        <o-list
            vuex-action-fetch="fetchUsers"
            vuex-action-fetch-next-page="fetchUsersNextPage"
            vuex-getter-model="users"
            vuex-getter-status="usersStatus"
            router-single-name="user"
        >
            <template slot="list" slot-scope="props">
                <p class="m-list__itemTitle m-list__itemTitle--margins m-list__itemTitle--capitalize">
                    {{ props.list.item.first_name }} {{ props.list.item.last_name }}
                </p>
            </template>
        </o-list>
    </div>
</template>

<script>
export default {
    metaInfo: {
        title: 'Użytkownicy'
    },
    computed: {
    },
    mounted() {
        this.$store.dispatch('fetchUsers').catch(() => {})
    }
}
</script>
